import React from 'react';

// Styles & Assets
import styles from './ErrorPage.module.css';

// ErrorPage: Returns the fallback page when an error occurs.
const ErrorPage: React.FC = () => {

    return(
        <div className={styles.errorPageWrapper}>
            <h1>404 Not Found</h1>
            <h2>This page could not be reached.</h2>
        </div>
    );
};

export default ErrorPage;